export const DaysFilterList = [
    { _id: "all", label: "Tout", labelKey: "filters.all" },
    { _id: "today", label: "Jour", labelKey: "filters.today" },
    { _id: "week", label: "Semaine", labelKey: "filters.week" },
    { _id: "month", label: "Mois", labelKey: "filters.month" },
    { _id: "custom", label: "Personnalisé", labelKey: "filters.custom" },
];